import React from "react";
import ApplicationTransactions from "../../features/applicationtransactions";

const ApplicationTransactionsPage = () => <ApplicationTransactions />

export default ApplicationTransactionsPage;